import React from "react";
import { connect } from "react-redux";
import { servicios } from "./../properties";

var mostrarBanner;
const url = window.location.hash;

const mapState = (state) => {
	return 0;
};

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento });
		},
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		}
	};
};

class BannerApp extends React.Component {

	openUrl = () => {
		window.open('https://www.viviresincreible.com.mx', '_blank');
	}

	evento = (event) => {
		this.props.addEvento(event.target.alt);
	}

	componentDidMount = () => {
		if (url.includes("#!/gnp/registro-seguridad/") || url.includes("#!/registro-familiar/") || url.includes("#!/recuperar-contrasenia")) {
			mostrarBanner = false;
		} else {
			mostrarBanner = true;
		}
	}

	render() {
		return mostrarBanner !== false &&
			<div className="bannerApp">
				<div className="hide-xs hide-sm">
					<img src={require("../img/Banner_App_Soy_Cliente_GNP_Web_01.png")} useMap="#image-map" />
					<map name="image-map">
						<area target="_blank" alt="Google Play" title="Google Play" onClick={this.evento} href="http://onelink.to/bucp25" coords="144,389,199,405" shape="rect" />
						<area target="_blank" alt="App Store" title="App Store" onClick={this.evento} href="http://onelink.to/bucp25" coords="211,389,259,405" shape="rect" />
					</map>
				</div>
				<div className="hide-md hide-gt-md">
					<img src={require("../img/appbannerresp2020.jpg")} useMap="#image-mapresp" />
					<map name="image-mapresp">
						<area target="_blank" alt="Google Play" title="Google Play" onClick={this.evento} href="http://onelink.to/bucp25" coords="168,112,233,131" shape="rect" />
						<area target="_blank" alt="App Store" title="App Store" onClick={this.evento} href="http://onelink.to/bucp25" coords="243,112,301,131" shape="rect" />
					</map>
				</div>
			</div>;
	}
}
export default connect(mapState, mapDispatch)(BannerApp);



// WEBPACK FOOTER //
// ./src/home/bannerApp.cmpt.js